// Modules
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import {
  Component,
  ElementRef,
  HostListener,
  Input,
  ViewChild,
} from '@angular/core';

@Component({
    selector: 'sbi-cot-back-file-upload',
    templateUrl: './file-upload.component.html',
    styleUrls: ['./file-upload.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: FileUploadComponent,
            multi: true,
        },
    ],
    standalone: false
})
export class FileUploadComponent implements ControlValueAccessor {
  @ViewChild('inputFile') inputFile;

  // Inputs
  @Input() accept: string;
  @Input() disabled: boolean;

  // Public variables
  public file: File | null = null;
  public onChange: Function;

  // Host Listener
  @HostListener('change', ['$event.target.files']) emitFiles(event: FileList) {
    const file = event && event.item(0);
    this.file = file;

    this.onChange(file);
  }

  // Constructor
  constructor(private _host: ElementRef<HTMLInputElement>) {}

  // Write Value method
  public writeValue(file: File): void {
    this._host.nativeElement.value = '';
    this.file = file;
  }

  // Register on change function
  public registerOnChange(fn: Function): void {
    this.onChange = fn;
  }

  // Register on touched function
  public registerOnTouched(): void {}

  // Public method to dispatch the file cancel action
  public onFileCancel(event: Event): void {
    event.preventDefault();

    this.file = null;
    this._host.nativeElement.value = '';
    this.inputFile.nativeElement.value = '';
    this.onChange(null);
  }
}
